import { Grid, Tooltip } from "@mui/material";

interface DoubleCellProps {
  left: any;
  right: any;
  tooltip?: string;
  justifyContent?: string;
}

const DoubleCell = (props: DoubleCellProps) => {
  const { left, right, justifyContent, tooltip } = props;

  return (
    <Tooltip title={tooltip ? tooltip : ""}>
      <Grid container spacing={1} alignItems="center" justifyContent={justifyContent} wrap="nowrap">
        <Grid item>{left}</Grid>
        <Grid item>{right}</Grid>
      </Grid>
    </Tooltip>
  );
};

export default DoubleCell;
